export const AUTO_ASSIGNMENT_RULE_FILTER_COLUMNS = {
  device: [
    'hostname',
    'vendor',
    'family',
    'model',
    'platform',
    'version',
    'sn',
  ],
  intL2: ['intName', 'intDscr'],
} as const;

export type AutoAssignmentRuleTargetType =
  keyof typeof AUTO_ASSIGNMENT_RULE_FILTER_COLUMNS;

export type AutoAssignmentRuleFilterColumn =
  (typeof AUTO_ASSIGNMENT_RULE_FILTER_COLUMNS)[AutoAssignmentRuleTargetType][number];

export const isAutoAssignmentRuleFilterColumn = (
  type: AutoAssignmentRuleTargetType,
  column: string,
): boolean =>
  (AUTO_ASSIGNMENT_RULE_FILTER_COLUMNS[type] as readonly string[]).includes(
    column,
  );
